<template>
  <v-container class="sidebar--navigation">
 <v-row justify-center>
    <v-col cols="12">
      <v-card elevation="2">
        <v-row no-gutters>
          <v-col cols="4"
              :style="{ paddingTop: '100px' }"
          >
            <v-img
              v-if="getProductImage(product.attributes) != ''"
              :src="getProductImage(product.attributes)"
              height="200"
              contain
            ></v-img>
             <v-img
                v-else
                :src="require('@/assets/images/logos/shopify.png')"
                height="200"
                contain
            ></v-img>
          </v-col>
          <v-col cols="8">
            <v-card-title class="text-h5 grey lighten-2">
              <v-img
                max-height="35"
                max-width="35"
                :src="require('@/assets/images/logos/shopify.png')"
              ></v-img>
              &nbsp;Product Details
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="product.id !== undefined">
              <v-row>
                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Title: {{ product.title }}</p>
                  <p class="font-weight-bold">SKU: {{ product.sku }}</p>
                  <p class="font-weight-bold d-flex align-center">
                    Vendor: <v-icon info class="mr-1">{{icons.mdiStore}}</v-icon>
                    {{ product.vendor }}
                  </p>
                    <p class="font-weight-bold" v-if="product.variations.length == 0">
                    Inventory Tracking:
                    <v-icon small :style="{ color: product.inventory_tracking === '1' ? '#077017' : 'red' }">
                      {{ product.inventory_tracking === '1' ? icons.mdiCheckCircle : icons.mdiCancel }}
                    </v-icon>
                      {{ product.inventory_tracking === '1' ? 'Tracked' : 'Not Tracked' }}
                  </p>
                  <p v-html="getWeightAndWeightUnit(product.attributes)"></p>
                </v-col>

                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Price: {{this.shop.currency }} {{ product.price }}</p>
                  <p class="font-weight-bold">Stock Quantity: {{ product.stock_quantity }}</p>
                  <p class="font-weight-bold">Published At: {{ product.published_at }}</p>
                  <p class="font-weight-bold">Description: {{ product.description }}</p>

                  <strong class="font-weight-bold"><u>Options:</u></strong>
                    <div v-for="option in getProductOptions(product.attributes)" :key="option.name">
                        <strong>{{ option.name }}:</strong>
                        <span v-for="(value, index) in option.values" :key="value">
                          {{ value }}<span v-if="index < option.values.length - 1">, </span>
                        </span>
                      </div>
                </v-col>

                <v-col cols="12" md="6">
                  <h4>Metafields:</h4>
                    <ul>
                      <li v-for="(value, key) in parseMetafields(product.metafields)" :key="key">
                        <span v-if="typeof value === 'object' && Object.keys(value).every(k => !isNaN(k))">
                          {{ formatMetafield(value) }}
                        </span>
                        <span v-else>
                          <strong>{{ key }}:</strong> {{ formatMetafield(value) }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
              </v-row>

              <!-- Add more product details as needed -->
            </v-card-text>
            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>Etsy Shop not Connected!!</h3>
              </div>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
    </br>


    <v-card class="p-1">
      <v-card-title>
         Product Variations
      </v-card-title>

      <v-data-table :headers="headers" :items="product.variations" disable-pagination hide-default-footer>
        <template v-slot:body="{ items }">
          <tbody v-if="!loading_data">
            <tr v-if="!items.length">
              <td colspan="6" class="text-center" style="padding: 20px 0px">
                <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
                <p style="font-size: 25px">No Data Found!!</p>
              </td>
            </tr>
            <tr v-else v-for="item in items" :key="item.id">
              <td>
               #{{ item.variant_id }}
              </td>
              <td style="padding: 4px"><img width="50px" :src="getProductImage(product.attributes, item.variant_id)" alt="" /></td>
              <td style="max-width: 300px; font-size: 12px">
                <strong v-html="getVariantTitle(item)"></strong>
              </td>
              <td>{{ item.sku }}</td>
              <td>
                <v-icon small :style="{ color: item.inventory_tracking === '1' ? '#077017' : 'red' }">
                      {{ item.inventory_tracking === '1' ? icons.mdiCheckCircle : icons.mdiCancel }}
                    </v-icon>
                      {{ item.inventory_tracking === '1' ? 'Tracked' : 'Not Tracked' }}
              </td>
              <td>
                  {{ item.stock_quantity}}
              </td>
              <td>
                {{shop.currency }} {{item.price}}
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center" style="padding: 80px 0px">
                <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    </br>

    <v-card class="p-1">
      <v-card-title>
        Product Media
      </v-card-title>

      <v-tabs v-model="media_tab">
        <v-tab>Images</v-tab>
        <v-tab>Videos</v-tab>
      </v-tabs>

      <v-tabs-items v-model="media_tab">
        <!-- Images Tab -->
        <v-tab-item>
            <v-card-text style="padding-top: 24px;">
            <v-row
              v-if="getProductImages().length > 0"
              no-gutters
            >
              <v-col
                v-for="(imageUrl, index) in getProductImages()"
                :key="index"
                cols="12"
                md="3"
                sm="4"
              >
                <v-img
                  :src="imageUrl"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  contain
                  max-width="100"
                  max-height="100"
                ></v-img>
              </v-col>
            </v-row>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Images Found</p>
            </div>
          </v-card-text>
        </v-tab-item>

        <!-- Videos Tab -->
        <v-tab-item>
          <v-card-text style="padding-top: 24px;">
            <div v-if="videos.length > 0">
              <v-card
                v-for="(video, index) in videos"
                :key="index"
                class="mb-3"
                outlined
              >
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-avatar size="80" color="grey lighten-2">
                        <v-icon size="40" color="primary">{{ icons.mdiPlay }}</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <p class="mb-1">
                        <strong>Video {{ index + 1 }}</strong>
                      </p>
                      <p v-if="video.sources && video.sources[0]" class="text-caption grey--text mb-0">
                        Format: {{ video.sources[0].format }} |
                        Resolution: {{ video.sources[0].width }}x{{ video.sources[0].height }}
                      </p>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        color="primary"
                        @click="openVideoDialog(video)"
                      >
                        <v-icon left>{{ icons.mdiPlay }}</v-icon>
                        Play Video
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Videos Found</p>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Video Popup Dialog -->
    <v-dialog v-model="video_dialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <span>Video Player</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeVideoDialog">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-if="selected_video && getVideoUrl(selected_video)">
            <video
              :src="getVideoUrl(selected_video)"
              controls
              style="width: 100%; max-width: 100%;"
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else class="text-center pa-4">
            <p>Video URL not available</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeVideoDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import store from '@/store'
import { mdiChevronDown, mdiClose, mdiCheckCircle, mdiStore, mdiCancel, mdiPlay } from '@mdi/js'
import { get } from 'lodash';
export default {
  data() {
    return {
      productId: null,
      product: {},
      loading_data: false,
      shop: null,
      videos: [],
      video_dialog: false,
      selected_video: null,
      media_tab: 0,
      headers: [
        {
          text: 'Variant ID',
          value: 'variant_id',
        },
        {
          text: 'Image',
        },
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'SKU',
          value: 'sku',
        },
        {
          text: 'Inventory Tracking',
          value: 'inventory_tracking',
        },
        {
          text: 'Inventory',
        },

        {
          text: 'Price',
        },
      ],
      icons: {
        mdiChevronDown,
        mdiClose,
        mdiCheckCircle,
        mdiCancel,
        mdiStore,
        mdiPlay
      },
      variation_headers: [
        {
          text: 'Attributes',
        },
        { text: 'SKU' },
        { text: 'Price' },
        { text: 'Stock' },
      ],

    }
  },

  async mounted() {
    this.productId = this.$route.params.product_id;
    this.shop = store.getters.loggedInShop
    this.fetchShopifyProduct()
  },

  methods: {

     async fetchShopifyProduct() {
      try {
        this.loading_data = true
        let response = await axios.get(`admin/shops/${this.shop.id}/shopify-product/${this.productId}`, {
        })
        if (response.data.success) {
          this.product = response.data.product
          this.videos = response.data.videos || []
          // this.is_first = false
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading_data = false
      }
    },

    getProductImage(product_attributes, variant_id = null) {
      // Validate input before parsing
      if (!product_attributes || product_attributes === 'undefined' || product_attributes === 'null') {
        return '';
      }

      try {
        const parsedAttributes = JSON.parse(product_attributes);
        let img_url = '';

        if (variant_id && Array.isArray(parsedAttributes.images)) {
          // Find first image that includes this variant_id
          const imageForVariant = parsedAttributes.images.find(img =>
              Array.isArray(img.variant_ids) && img.variant_ids.includes(String(variant_id))
          );
          if (imageForVariant) {
            img_url = imageForVariant.src;
          }
        }

        // Fallback: first image
        if (!img_url && Array.isArray(parsedAttributes.images) && parsedAttributes.images[0]) {
          img_url = parsedAttributes.images[0].src;
        }

        // Fallback: single image_url property
        if (!img_url) {
          img_url = parsedAttributes?.image_url || '';
        }

        return img_url;
      } catch (e) {
        console.error('Error parsing product attributes:', e);
        return '';
      }
    },

    getWeightAndWeightUnit(attributes){
      let prodAttr = JSON.parse(attributes);
      if(prodAttr.weight && prodAttr.weight_unit){
        return "<strong>Weight: </strong>" + prodAttr.weight + " " + prodAttr.weight_unit;
      }
      return '<strong>Weight: </strong>Not Set';
    },

     parseAttributes(attributes) {
      try {
        return JSON.parse(attributes);
      } catch (error) {
        console.error('Error parsing attributes:', error);
        return {};
      }
    },

    capitalizeFirstLetters(str) {
      return str
        .split(', ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(', ');
    },

    parseMetafields(metafields) {
      if (!metafields) return {};

      let parsed = {};
      try {
        parsed = JSON.parse(metafields);
      } catch (e) {
        console.error('Error parsing metafields:', e);
        return {};
      }

      // If parsed is an array, convert to object with numeric keys
      if (Array.isArray(parsed)) {
        const obj = {};
        parsed.forEach((v, i) => (obj[i] = v));
        parsed = obj;
      }

    return parsed;
  },

    formatMetafield(value) {
      if (Array.isArray(value)) {
        return value.map(v => this.formatMetafield(v)).join(', ');
      }

      if (typeof value === 'object' && value !== null) {
        // Special case: object has 'value' and 'unit' → show nicely
        if ('value' in value && 'unit' in value) {
          return `${value.value} ${value.unit.toLowerCase()}`;
        }

        // Only numeric keys starting from 0 → show values only
        const keys = Object.keys(value);
        const isArrayLike = keys.every(k => !isNaN(k));
        if (isArrayLike) {
          return keys.map(k => this.formatMetafield(value[k])).join(', ');
        }

        // Otherwise show key: value recursively
        return Object.entries(value)
          .map(([k, v]) => `${k}: ${this.formatMetafield(v)}`)
          .join(', ');
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();

        // If string is JSON array/object
        if ((trimmed.startsWith('[') && trimmed.endsWith(']')) ||
            (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
          try {
            const parsed = JSON.parse(trimmed.replace(/'/g, '"'));
            return this.formatMetafield(parsed); // recursive
          } catch (e) {
            return value;
          }
        }

        return value;
      }

      return value ?? '';
    },

    getVariantTitle(item)
    {
      try {
        const variations = JSON.parse(item.attributes).variations;
        return Object.entries(variations)
          .map(([key, value]) => `${key}: ${value}`)
          .join('<br>');
      } catch (e) {
        return JSON.parse(item.attributes).title;
      }
    },

    getProductOptions(attributes) {
      try {
        const parsed = JSON.parse(attributes);
        if (!parsed.options || !Array.isArray(parsed.options)) return [];

        return parsed.options.map(option => ({
          name: option.name,
          values: option.values || []
        }));
      } catch (e) {
        console.error('Error parsing options:', e);
        return [];
      }
    },

    getProductImages() {
      try {
        if (!this.product.attributes) return [];
        const attributes = JSON.parse(this.product.attributes);
        if (attributes.images && Array.isArray(attributes.images)) {
          return attributes.images.map(img => img.src).filter(src => src);
        }
        return [];
      } catch (e) {
        console.error('Error parsing product images:', e);
        return [];
      }
    },

    getVideoUrl(videoData) {
      if (!videoData) return '';

      // Try sources[0].url first
      if (videoData.sources && Array.isArray(videoData.sources) && videoData.sources.length > 0) {
        return videoData.sources[0].url || '';
      }

      // Fallback to originalSource.url
      if (videoData.originalSource && videoData.originalSource.url) {
        return videoData.originalSource.url;
      }

      return '';
    },

    openVideoDialog(videoData) {
      this.selected_video = videoData;
      this.video_dialog = true;
    },

    closeVideoDialog() {
      this.video_dialog = false;
      this.selected_video = null;
    }
  }
}
</script>
